import { AmplitudeSessionReplayProvider } from "@redotech/redo-merchant-analytics-app/analytics/amplitude-session-replay-provider";
import { memo, type ComponentType } from "react";

type PageVisibility = (url: string, search: { search: string }) => boolean;

export type RoutePageComponent = ComponentType<{
  hideHeader?: PageVisibility;
  hideNavbar?: PageVisibility;
  hidePadding?: PageVisibility;
}>;

export const SessionReplayRoutePage = memo(function SessionReplayRoutePage({
  enabled,
  hideHeader,
  hideNavbar,
  hidePadding,
  Page,
  productId,
}: {
  enabled: boolean;
  hideHeader: PageVisibility;
  hideNavbar: PageVisibility;
  hidePadding: PageVisibility;
  Page: RoutePageComponent;
  productId: string;
}) {
  return (
    <AmplitudeSessionReplayProvider enabled={enabled} productId={productId}>
      <Page
        hideHeader={hideHeader}
        hideNavbar={hideNavbar}
        hidePadding={hidePadding}
      />
    </AmplitudeSessionReplayProvider>
  );
});
